import { CONTAINER_MARGIN, DOT_GAP, DOT_STEP, DOT_WIDTH } from './constants';

/**
 * Calculate which dots should be visible and their offset for animation
 */
export function calculateVisibleDots(
  currentIndex: number,
  totalSlides: number,
  maxVisible = 5
): { dots: number[]; offset: number } {
  if (totalSlides <= maxVisible) {
    return {
      dots: Array.from({ length: totalSlides }, (_, i) => i),
      offset: 0,
    };
  }

  let start: number;
  let offset: number;

  // Start of carousel - show first maxVisible dots
  if (currentIndex <= 2) {
    start = 0;
    offset = 0;
  }
  // End of carousel - show last maxVisible dots
  else if (currentIndex >= totalSlides - 3) {
    start = totalSlides - maxVisible;
    offset = -(totalSlides - maxVisible) * DOT_STEP;
  }
  // Middle - center current dot
  else {
    start = currentIndex - 2;
    offset = -start * DOT_STEP;
  }

  return {
    dots: Array.from({ length: maxVisible }, (_, i) => start + i),
    offset,
  };
}

/**
 * Calculate container width for dots
 */
export function calculateDotsContainerWidth(visibleCount: number): string {
  return `calc(${visibleCount} * ${DOT_WIDTH}px + (${visibleCount} - 1) * ${DOT_GAP}px + ${CONTAINER_MARGIN}px)`;
}
